import React, { useState, useRef, useEffect, useContext } from "react";
import Lottie from "react-lottie";
import loader from "../../assets/Loader/AssetLoader.json";
import TickerContext from "../../context/ticker";
import MyContext from "../../context/MyContext";

const VideoPlayer = ({ value, onePx, VideoPlayerRef }) => {
  const [VideoLoaded, setVideoLoaded] = useState(false);
  const videoref = useRef(null);
  const [CurrTime, setCurrTime] = useState(0);

  const { TickerPosition } = useContext(TickerContext);
  const { CanvasDisplay } = useContext(MyContext);

  // useEffect(() => {

  //     if (value.player) {
  //         videoref.current.play()
  //         // VideoPlayerRef.current.play()
  //     } else {
  //         videoref.current.pause()
  //         // VideoPlayerRef.current.pause()
  //     }
  // }, [value.player])

  // useEffect(() => {
  //     var element = document.getElementsByClassName('single-resizer')
  //     for (let SubElement of element) {
  //         if (SubElement.firstChild) {
  //             if (!SubElement.classList.contains('RectBorder')) {
  //                 //SubElement.style.zIndex = 3000
  //                 SubElement.classList.add("RectBorder");
  //             }
  //         }
  //         // else {
  //         //     if (SubElement.classList.contains('RectBorder'))
  //         //         SubElement.style.zIndex = 2000
  //         //     SubElement.classList.remove("RectBorder");
  //         // }
  //     }

  // }, [value.Editable])

  // useEffect(() => {
  //     if (CurrTime != 0) {
  //         // videoref.current.currentTime = CurrTime
  //         if(VideoPlayerRef.current)
  //             VideoPlayerRef.current.currentTime = CurrTime;
  //     }
  // }, [CurrTime])

  // useEffect(() => {
  //     if (VideoLoaded) {
  //         if (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) {
  //             let ms = (TickerPosition - value.startPositionOnTimeline) * onePx
  //             var sec = (ms / 1000).toFixed(1)
  //             console.log("Timeline Video...........", sec)
  //             setCurrTime(sec)
  //         }
  //     }
  // }, [TickerPosition])
 const generateTransformClass = () =>{
    if(value.flip){
      if(CanvasDisplay){
        return  value.flip;
      }
      else{
        return `rotate(${value.rotateAngle}deg) ` + value.flip;
      }
    }
    else{
      if(CanvasDisplay){
        return  value.flip;
      }
      else{
        return `rotate(${value.rotateAngle}deg)`;
      }
    }
 }
  return (
    <>
      <div
        className="VideosDiv"
        style={{ display: value.InMultiDrag ? "none" : "block" }}
      >
        {/* <img className="selectedVideo" draggable="false" tabIndex="0" src={value.ImageSrc}
                style={{ transform: value.flip, opacity: value.opacity }} /> */}

        {VideoLoaded == false && (
          <Lottie
            options={{ loop: true, autoplay: true, animationData: loader }}
            isStopped={false}
            isPaused={false}
          />
        )}
        <video
          preload="true"
          id={"Video-" + value.AnimationId}
          ref={videoref}
          playsInline
          style={{
            width: "100%",
            height: "100%",
            transform:generateTransformClass(),
            opacity: value.opacity,
            display: value.opc === 1 ? "block" : "none",
          }}
          src={value.url}
          onLoadedData={(e) => {
            setVideoLoaded(true);
          }}
        />
      </div>
    </>
  );
};

export default VideoPlayer;
